import styles from './style.module.css'
import { Padding } from './types'

function capitalizeFirstLetter(word: string): string {
  if (!word) {
    return ''
  }
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const getPaddingStyle = (padding: Padding | undefined): string[] | string | null => {
  if (typeof padding === 'object') {
    return Object.entries(padding).map(([name, size]) => styles[`padding${capitalizeFirstLetter(name)}${size}`])
  } else if (typeof padding === 'string') {
    return styles[`padding${padding}`]
  }
  return null
}
